module.exports = require("github:jspm/nodelibs-process@0.1.2/index");